import { Rect } from "./types";

/** Shared position/size + axis-aligned bounds for all game objects. */
export abstract class Entity {
  x: number;
  y: number;
  width: number;
  height: number;

  constructor(x: number, y: number, width: number, height: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
  }

  get rect(): Rect {
    return { x: this.x, y: this.y, width: this.width, height: this.height };
  }
}
